import React, { useEffect } from "react";
import styles from "../ArticleComponents/Common.module.css";
import ArticleCoverAndHeader from "../ArticleComponents/ArticleCoverAndHeader";
import Row from "../ArticleComponents/Row";
import styles1 from "./HowItSpreads.module.css";

function HowItSpreads() {
    const rows = [
        {
            heading:"What you need to know?",
            listItem:["Anyone can have mild to severe symptoms.",
            "Older adults and people who have severe underlying medical conditions (they are termed as co-morbidities in medical terms) like heart or lung disease or diabetes seem to be at higher risk for developing more serious complications from COVID-19 illness."]
        },
        {
            heading:"The most common symptoms",
            image_url:"https://drive.google.com/thumbnail?id=1_7D85dgAGtudloGi-Dekh09RXty9aIJd",
            listItem:["Fever or chills","Cough","Shortness of breath or difficulty breathing","Fatigue","Muscle or body aches","Headache","New loss of taste or smell","Sore throat","Congestion or runny nose","Nausea or vomiting","Diarrhoea",]
        },
        {
            heading:"Serious symptoms",
            listItem:["difficulty breathing or shortness of breath","chest pain or pressure","loss of speech or movement","On average it takes 5–6 days from when someone is infected with the virus for symptoms to show, however it can take up to 14 days."]
        },
    ]

    const rows1 = {
      listItem:["The respiratory droplets are the major way in which the virus spreads, when a person is less than 1 metre apart from an infected person.", "Aerosol droplets are smaller in size, and lead to infection in certain settings, especially indoor , crowded and inadequately ventilated spaces, where infected person(s) spend long periods of time with others. There are studies still going on spread of the virus via aerosol droplets."]
    }


  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });

  return (
    <ArticleCoverAndHeader
      readTime={4}
      title="How Covid Spreads?"
      author="Anushka Dixit"
      authorLink="https://www.instagram.com/anushkadixit1708/"
      previousGuide="/first-aid-at-home"
    >
      <div className={styles.introPara}>
        <p>
        On 25th April 2021, India reported <span className={styles.highlight}>346,786 new cases</span> of COVID-19 for the previous 24
        hours, with <span className={styles.highlight}>2,624 deaths</span> – the <span className={styles.highlight}>world’s highest daily toll</span> since the pandemic began last year.
        There are endless lines for hospital beds, people are dying due to lack of oxygen and our
        resources are stretched thin. The new variant of the virus has people crying for help, doctors
        breaking down and the world praying for India.
        The words <span className={styles.highlight}>“Prevention is better than cure”</span> have never rung truer. Now, more than ever when
        our news is full of people dying and crying for help, when twitter is overflowing with SOS
        calls and people are not getting space to burn or bury their dead, it is important that we make {" "}
        <span className={styles.highlight}>prevention our weapon</span>. For effective prevention, it is necessary to know how the disease
        spreads, and what can we do to avoid getting infected:
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
        How does COVID-19 spread between people?
      </h2>
      <div className={styles.introPara}>
        <p>
          Bottom line? When a person comes in contact with an infected person,
          they also get infected. When you come in contact with an individual
          who has been infected with any variety of the Covid-19 virus, you have
          a very high chance of contacting the disease when the{" "}
          <span className={styles.highlight}>
            infected person coughs, sneezes, sings, speaks or even breathes
            heavily{" "}
          </span>
          . These actions release droplets of different sizes containing
          infection which, once in your eyes, nose or mouth, leaves you
          infected. These droplets can be divided into two categories: the {" "}
          <span className={styles.highlight}>larger respiratory droplets</span> and <span className={styles.highlight}>smaller aerosol droplets</span>
        </p>
      </div>

      <Row row={rows1} />

      <h2 className={styles.sliderHeader}>That's not all!</h2>
      <div className={styles.introPara}>
        <p>
          While the major way of the virus to spread remains through <span className={styles.highlight}> direct
          contact </span>, the virus can also spread indirectly through surfaces touched
          by infected people when they <span className={styles.highlight}>sneeze, cough on, or touch
          surfaces, or objects, such as tables, doorknobs and handrails </span>. Other
          people may become infected by touching these contaminated surfaces,
          then touching their eyes, noses or mouths without having cleaned their
          hands first. That is exactly why <span className={styles.highlight}> washing your hands </span> and <span className={styles.highlight}> sanitizing {" "}
          them </span> is so important!
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
        Can asymptomatic people transmit the virus?
      </h2>
      <div className={styles.introPara}>
        <p>
        <span className={styles.highlight}>Yes!</span> Whether or not they have symptoms, infected people can be
          contagious and the virus can spread from them to other people. Studies
          tell us that <span className={styles.highlight}> infected people appear to be most infectious just before
          they develop symptoms </span> (namely 2 days before they develop symptoms) and
          early in their illness. People who develop severe disease can be
          infectious for longer.
        </p>
      </div>

      <h2 className={styles.sliderHeader}>
        Is it possible for the virus to spread more easily in some settings?
      </h2>

      <div className={styles.introPara}>
        <p>
          The virus can spread very easily in <span className={styles.highlight}>crowded places, close contact
          settings and confined places </span>, or like the WHO calls it- <span className={styles.highlight}> the 3C’s </span>. The
          best possible way to avoid getting infected is to avoid these places
          and stay home as far as possible.
        </p>
      </div>

      <div className={styles1.imgSection}>
        <img
          src="https://www.who.int/images/default-source/health-topics/coronavirus/3cs-poster-for-hq.tmb-768v.jpg?sfvrsn=ae03ff52_2"
          alt="associated-image"
        />
      </div>
    </ArticleCoverAndHeader>
  );
}

export default HowItSpreads;
